import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { ElderShellService } from '@elderbyte/ngx-starter'
import { ProductionCode } from '../production-code'
import { ProductionCodeDetailComponent } from '../production-code-detail/production-code-detail.component'

@Component({
  selector: 'app-production-code-detail-side',
  templateUrl: './production-code-detail-side.component.html',
  styleUrls: ['./production-code-detail-side.component.scss'],
  imports: [ProductionCodeDetailComponent],
})
export class ProductionCodeDetailSideComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public prodCode: ProductionCode
  private shellService = inject(ElderShellService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const route = inject(ActivatedRoute)
    this.prodCode = route.snapshot.data['prodCode']
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onClose(event: Event): void {
    this.shellService.closeSideContent()
  }
}
